var map = {
	"./blocklistUrlInfoPopover.pug": 4125,
	"./whitelistFullDataInfoPopover.pug": 4126,
	"./whitelistUrlInfoPopover.pug": 4127,
	"./whitelistUserPromptsInfoPopover.pug": 4128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4124;